export const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const REQUEST_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ASSIGNED: 'ASSIGNED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
}

export const VEHICLE_CATEGORY = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
}

export const SYSTEM_PERMISSIONS = {
  DASHBOARD_READ: 'dashboard-read',
  DASHBOARD_WRITE: 'dashboard-write',
  DASHBOARD_DELETE: 'dashboard-delete',
  REQUESTS_READ: 'requests-read',
  REQUESTS_WRITE: 'requests-write',
  REQUESTS_DELETE: 'requests-delete',
  SETTINGS_READ: 'settings-read',
  SETTINGS_WRITE: 'settings-write',
  SETTINGS_DELETE: 'settings-delete',
  USERS_READ: 'users-read',
  USERS_WRITE: 'users-write',
  USERS_DELETE: 'users-delete',
  ZONES_READ: 'zones-read',
  ZONES_WRITE: 'zones-write',
  ZONES_DELETE: 'zones-delete',
  TRUCKS_READ: 'trucks-read',
  TRUCKS_WRITE: 'trucks-write',
  TRUCKS_DELETE: 'trucks-delete'
}